// extracted by mini-css-extract-plugin
export default {"input-field":"checkbox_input-field__SQJOJ","description":"checkbox_description__-GF9H","label-checkbox-wrapper":"checkbox_label-checkbox-wrapper__HHrMw"};